import type { Endpoint } from ".";

export const listProperties: Endpoint = {
  id: "listProperties",
  method: "GET",
  path: "/projects/{project_id}/properties",
  summary: "List properties",
  description:
    "Returns all properties within the given project. Sorted by name ascending.",
  params: [
    {
      name: "project_id",
      in: "path",
      required: true,
      description: "UUID of the project.",
      type: "uuid",
      defaultFromClientId: true,
    },
  ],
};
